export default "__VITE_ASSET__B1gQL17a__"